/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

const mutations = {
    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu

    TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
        state.isVerticalNavMenuActive = value;
    },
    TOGGLE_REDUCE_BUTTON(state, val) {
        state.reduceButton = val;
    },
    UPDATE_MAIN_LAYOUT_TYPE(state, val) {
        state.mainLayoutType = val;
    },
    UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
        state.verticalNavMenuItemsMin = val;
    },
    UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
        state.verticalNavMenuWidth = width;
    },

    // VxAutoSuggest

    UPDATE_STARRED_PAGE(state, payload) {
        // find item index in search list state
        const index = state.navbarSearchAndPinList["pages"].data.findIndex(
            (item) => item.url == payload.url
        );

        // update the main list
        state.navbarSearchAndPinList["pages"].data[index].is_bookmarked =
            payload.val;

        // if val is true add it to starred else remove
        if (payload.val) {
            state.starredPages.push(
                state.navbarSearchAndPinList["pages"].data[index]
            );
        } else {
            // find item index from starred pages
            const index = state.starredPages.findIndex(
                (item) => item.url == payload.url
            );

            // remove item using index
            state.starredPages.splice(index, 1);
        }
    },

    // Navbar-Vertical

    ARRANGE_STARRED_PAGES_LIMITED(state, list) {
        const starredPagesMore = state.starredPages.slice(10);
        state.starredPages = list.concat(starredPagesMore);
    },
    ARRANGE_STARRED_PAGES_MORE(state, list) {
        let downToUp = false;
        let lastItemInStarredLimited = state.starredPages[10];
        const starredPagesLimited = state.starredPages.slice(0, 10);
        state.starredPages = starredPagesLimited.concat(list);

        state.starredPages.slice(0, 10).map((i) => {
            if (list.indexOf(i) > -1) downToUp = true;
        });

        if (!downToUp) {
            state.starredPages.splice(10, 0, lastItemInStarredLimited);
        }
    },

    // ////////////////////////////////////////////
    // UI
    // ////////////////////////////////////////////

    TOGGLE_CONTENT_OVERLAY(state, val) {
        state.bodyOverlay = val;
    },
    UPDATE_PRIMARY_COLOR(state, val) {
        state.themePrimaryColor = val;
    },
    UPDATE_THEME(state, val) {
        state.theme = val;
    },
    UPDATE_WINDOW_WIDTH(state, width) {
        state.windowWidth = width;
    },
    UPDATE_WINDOW_SCROLL_Y(state, val) {
        state.scrollY = val;
    },

    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////

    // Updates user info in state and localstorage
    UPDATE_USER_INFO(state, payload) {
        // Get Data localStorage
        let userInfo =
            JSON.parse(localStorage.getItem("userInfo")) || state.AppActiveUser;

        for (const property of Object.keys(payload)) {
            if (payload[property] != null) {
                // If some of user property is null - user default property defined in state.AppActiveUser
                state.AppActiveUser[property] = payload[property];

                // Update key in localStorage
                userInfo[property] = payload[property];
            }
        }
        // Store data in localStorage
        // Update 13022026_1111 : Remove password from localStorage
        const userInfoToStore = { ...userInfo };
        delete userInfoToStore.password;
        localStorage.setItem("userInfo", JSON.stringify(userInfoToStore));
    },

    UPDATE_SITE_INFO(state, payload) {
        state.sites = payload;
    },
    UPDATE_AREA_INFO(state, payload) {
        state.areas = payload;
    },
    UPDATE_COMPANY_INFO(state, payload) {
        state.companies = payload;
    },
    UPDATE_CURRENT_SITE(state, payload) {
        state.currentSite = state.sites.find(x => x.id == payload);
    },
    UPDATE_CURRENT_AREA(state, payload) {
        state.currentArea = state.areas.find(x => x.id == payload);
    },
    UPDATE_CURRENT_COMPANY(state, payload) {
        state.currentCompany = state.companies.find(x => x.id == payload);
    },
    UPDATE_CURRENT_CAMERA(state, payload) {
        state.currentCamera = payload;
    },
    UPDATE_REPORT_STATE(state, payload) {
        state.reportState = payload;
    },
    UPDATE_CURRENT_USER(state, payload) {
        state.currentUser = payload;
    },
    SAVE_SITE_FORM(state, payload) {
        state.currentSiteForm = payload;
    },
    UPDATE_GENERAL_DATA(state, payload) {
        state.generalData = payload
        localStorage.setItem("generalData", JSON.stringify(payload));
    },
    EMBED_ACCESS(state, payload) {
        state.currentUser = payload;
    },
    EVENT_LISTS(state, payload) {
        state.events = payload;
    },
    UPDATE_SELECTED_SITE(state, payload) {
        state.selectedSite = payload;
    },
    SET_IS_IN_OUT(state, data) {
        state.isInOut = data;
    },
};

export default mutations;